define((require) => {
    "use strict";

    const {extend}                             = require("underscore");
    const ChannelSetupManualView               = require("ui/publish/channelSetup/ChannelSetupManualView");
    const ProjectDashboardChannelSetupItemView = require("ui/projects/publish/ProjectDashboardChannelSetupItemView");

    /**
     * Subclass of ChannelSetupManualView representing the Channel dashboard in a project context. <p>
     *
     * @class ProjectDashboardChannelSetupManualView
     * @see ChannelSetupManualView
     * @see ProjectDashboardChannelSetupItemView
     */
    return ChannelSetupManualView.extend({

        viewOptions: {
            showAttachButton: true,
            showAttachActions: false,
            showCreateSlotField: true,
            showCreateSlotInProjectLabel: true,
            showPublishButton: true,
            showAttachHeader: false,
            showChannelActionsPanel: true
        },

        initialize() {
            this.collectionViewOptions = {
                itemView: ProjectDashboardChannelSetupItemView,
                itemEvents: {
                    detach(model) {
                        this.collection.remove(model);
                    }
                }
            };

            this.__super();
        },

        ui() {
            return extend({}, ChannelSetupManualView.prototype.ui, {
                attachButton: ".attach-button"
            });
        },

        events() {
            return extend({}, ChannelSetupManualView.prototype.events, {
                "click @ui.attachButton": "_openAttachLightbox"
            });
        },

        _openAttachLightbox() {
            this.viewScope.openAttachLightbox(this.options);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/publish/ProjectDashboardChannelSetupManualView.js